import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

export const UpdateOfferLetterTemplateContentSkeleton = () => {
  return (
    <Box gap="s16">
      <Box gap="s8">
        <Skeleton width="s80" height="s12" />
        <Skeleton width="full" height="s12" />
      </Box>
      <Grid variant="fixed">
        <Box gap="s8" gridColSpan={{ xxs: 1, xs: 6 }}>
          <Skeleton width="s80" height="s12" />
          <Skeleton width="full" height="s12" />
        </Box>
        <Box gap="s8" gridColSpan={{ xxs: 1, xs: 6 }}>
          <Skeleton width="s80" height="s12" />
          <Skeleton width="full" height="s12" />
        </Box>
      </Grid>
      <Box gap="s8">
        <Skeleton width="s80" height="s12" />
        <Skeleton width="full" height="s12" />
      </Box>
    </Box>
  )
}
